import type { TFunction } from "i18next";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonFavoritesData = (t: TFunction) => ({
  heading: t("anonymous:favorites.upperTitle"),
  mark: t("anonymous:favorites.lowerTitle"),
  punch: t("anonymous:favorites.description"),
  cards: [
    {
      title: t("anonymous:favorites.feature.quickAccess.title"),
      body: t("anonymous:favorites.feature.quickAccess.description"),
      icon: "ZAP",
    },
    {
      title: t("anonymous:favorites.feature.stayInspired.title"),
      body: t("anonymous:favorites.feature.stayInspired.description"),
      icon: "LIGHT",
    },
    {
      title: t("anonymous:favorites.feature.yourCollection.title"),
      body: t("anonymous:favorites.feature.yourCollection.description"),
      icon: "LIBRARY_BIG",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonFavoritesLorebooksData = (t: TFunction) => ({
  heading: t("anonymous:favoritesLorebooks.upperTitle"),
  mark: t("anonymous:favoritesLorebooks.lowerTitle"),
  punch: t("anonymous:favoritesLorebooks.description"),
  cards: [
    {
      title: t("anonymous:favoritesLorebooks.feature.quickAccess.title"),
      body: t("anonymous:favoritesLorebooks.feature.quickAccess.description"),
      icon: "ZAP",
    },
    {
      title: t("anonymous:favoritesLorebooks.feature.stayInspired.title"),
      body: t("anonymous:favoritesLorebooks.feature.stayInspired.description"),
      icon: "LIGHT",
    },
    {
      title: t("anonymous:favoritesLorebooks.feature.yourCollection.title"),
      body: t("anonymous:favoritesLorebooks.feature.yourCollection.description"),
      icon: "LIBRARY_BIG",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonCreationsData = (t: TFunction) => ({
  heading: t("anonymous:creations.upperTitle"),
  mark: t("anonymous:creations.lowerTitle"),
  punch: t("anonymous:creations.description"),
  cards: [
    {
      title: t("anonymous:creations.feature.oneView.title"),
      body: t("anonymous:creations.feature.oneView.description"),
      icon: "EARTH",
    },
    {
      title: t("anonymous:creations.feature.watchGrow.title"),
      body: t("anonymous:creations.feature.watchGrow.description"),
      icon: "CHART_NO_AXES_COMBINED",
    },
    {
      title: t("anonymous:creations.feature.fineTune.title"),
      body: t("anonymous:creations.feature.fineTune.description"),
      icon: "SLIDER_VERTICAL",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonVoiceData = (t: TFunction) => ({
  heading: t("anonymous:createVoice.upperTitle"),
  mark: t("anonymous:createVoice.lowerTitle"),
  punch: t("anonymous:createVoice.description"),
  cards: [
    {
      title: t("anonymous:createVoice.feature.voiceCloning.title"),
      body: t("anonymous:createVoice.feature.voiceCloning.description"),
      icon: "USERS",
    },
    {
      title: t("anonymous:createVoice.feature.mixCreativity.title"),
      body: t("anonymous:createVoice.feature.mixCreativity.description"),
      icon: "SLIDER_VERTICAL",
    },
    {
      title: t("anonymous:createVoice.feature.personalTouch.title"),
      body: t("anonymous:createVoice.feature.personalTouch.description"),
      icon: "EDIT",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonPersonaData = (t: TFunction) => ({
  heading: t("anonymous:myPersonas.upperTitle"),
  mark: t("anonymous:myPersonas.lowerTitle"),
  punch: t("anonymous:myPersonas.description"),
  cards: [
    {
      title: t("anonymous:myPersonas.feature.personalContext.title"),
      body: t("anonymous:myPersonas.feature.personalContext.description"),
      icon: "VENETIAN_MASK",
    },
    {
      title: t("anonymous:myPersonas.feature.customVibes.title"),
      body: t("anonymous:myPersonas.feature.customVibes.description"),
      icon: "WAND_SPARKLES",
    },
    {
      title: t("anonymous:myPersonas.feature.seamlessSwitching.title"),
      body: t("anonymous:myPersonas.feature.seamlessSwitching.description"),
      icon: "ARROW_LEFT_RIGHT",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonChatbotData = (t: TFunction) => ({
  heading: t("anonymous:createChatbot.upperTitle"),
  mark: t("anonymous:createChatbot.lowerTitle"),
  punch: t("anonymous:createChatbot.description"),
  cards: [
    {
      title: t("anonymous:createChatbot.feature.createPublic.title"),
      body: t("anonymous:createChatbot.feature.createPublic.description"),
      icon: "EARTH",
    },
    {
      title: t("anonymous:createChatbot.feature.createPrivate.title"),
      body: t("anonymous:createChatbot.feature.createPrivate.description"),
      icon: "EYE_OFF",
    },
    {
      title: t("anonymous:createChatbot.feature.getRewards.title"),
      body: t("anonymous:createChatbot.feature.getRewards.description"),
      icon: "TROPHY",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonGroupData = (t: TFunction) => ({
  heading: t("anonymous:createGroup.upperTitle"),
  mark: t("anonymous:createGroup.lowerTitle"),
  punch: t("anonymous:createGroup.description"),
  cards: [
    {
      title: t("anonymous:createGroup.feature.mixMatch.title"),
      body: t("anonymous:createGroup.feature.mixMatch.description"),
      icon: "BOT",
    },
    {
      title: t("anonymous:createGroup.feature.conversationalPlay.title"),
      body: t("anonymous:createGroup.feature.conversationalPlay.description"),
      icon: "DICES",
    },
    {
      title: t("anonymous:createGroup.feature.endlessExploration.title"),
      body: t("anonymous:createGroup.feature.endlessExploration.description"),
      icon: "COMPASS",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonLorebookData = (t: TFunction) => ({
  heading: t("anonymous:createLorebook.upperTitle"),
  mark: t("anonymous:createLorebook.lowerTitle"),
  punch: t("anonymous:createLorebook.description"),
  cards: [
    {
      title: t("anonymous:createLorebook.feature.buildUniverse.title"),
      body: t("anonymous:createLorebook.feature.buildUniverse.description"),
      icon: "EARTH",
    },
    {
      title: t("anonymous:createLorebook.feature.expandEase.title"),
      body: t("anonymous:createLorebook.feature.expandEase.description"),
      icon: "LAYERS",
    },
    {
      title: t("anonymous:createLorebook.feature.stayFlow.title"),
      body: t("anonymous:createLorebook.feature.stayFlow.description"),
      icon: "PEN_TOOL",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonLorebookDiscoverData = (t: TFunction) => ({
  heading: t("lorebook:anonymousDiscover.upperTitle"),
  mark: t("lorebook:anonymousDiscover.lowerTitle"),
  punch: t("lorebook:anonymousDiscover.description"),
  cards: [
    {
      title: t("lorebook:anonymousDiscover.feature.discoverWorlds.title"),
      body: t("lorebook:anonymousDiscover.feature.discoverWorlds.description"),
      icon: "ZAP",
    },
    {
      title: t("lorebook:anonymousDiscover.feature.readyToUse.title"),
      body: t("lorebook:anonymousDiscover.feature.readyToUse.description"),
      icon: "LIGHT",
    },
    {
      title: t("lorebook:anonymousDiscover.feature.communityMade.title"),
      body: t("lorebook:anonymousDiscover.feature.communityMade.description"),
      icon: "LIBRARY_BIG",
    },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getAnonData = (t: TFunction) => ({
  favorites: getAnonFavoritesData(t),
  favoritesLorebooks: getAnonFavoritesLorebooksData(t),
  creations: getAnonCreationsData(t),
  voice: getAnonVoiceData(t),
  persona: getAnonPersonaData(t),
  chatbot: getAnonChatbotData(t),
  group: getAnonGroupData(t),
  lorebook: getAnonLorebookData(t),
  lorebookDiscover: getAnonLorebookDiscoverData(t),
});

export default getAnonData;
